import i18n from '@/i18n';
import messages from "@/util/messages";
import alert from '@/util/global-alert';
import * as errs from '@/util/errors';
import { isNotEmpty } from '@/util/misc'
import store from '@/store'
import { LAST_TOKEN_UPDATE } from '@/store/consts'
import { NORMAL_DESIGN_DELAY } from '@/globals'
import fileDownload from 'js-file-download';
import router from '@/router/'
import {CODE_UNAUTHORIZED} from "@/util/errors";

const axios = require('axios');

// Имя свойства компонента, которе автоматически будет изменяться по ходу исполнения
// запроса к серверу.
const LOADING = 'loading';
export const AUTH_HEADER = 'authentication';
//const USER_AGENT_HEADER = 'user-agent';


export class RequestError extends Error {
    constructor(response = null, fatal = false, ...params) {
        // Pass remaining arguments (including vendor specific ones) to parent constructor
        super(...params)

        // Maintains proper stack trace for where our error was thrown (only available on V8)
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, RequestError)
        }
        this.name = 'RequestError'

        // Custom debugging information
        this.response = response
        this.fatal = fatal
        let hasBody = isNotEmpty(this.response) && isNotEmpty(this.response.data)
        this.isValid = hasBody && isValidResponse(this.response.data)

        this.firstError = this.isValid ? this.response.data.errors[0] : null

        // Для вывода на экран наиболее информативна последняя ошибка. См в бэке ошибки типа AppError->Auth
        this.lastError = this.isValid ? this.response.data.errors[this.response.data.errors.length - 1] : null

        this.code = this.fatal ?
            this.response ? this.response.status : -1
            : this.lastError.code;
        this.message = this.isValid ? backerror2message(this.code, this.lastError.message) :
            this.response ? i18n.t("error.wrongResponse") : i18n.t("error.requestError")
    }
}

export function wait(ms, value) {
    return new Promise(resolve => setTimeout(resolve, ms, value));
}

export default {
    install(Vue) {
        // busyFlag - Либо булеан, либо строка с именем свойства которое надо атоматически переключать
        //            false - не переключает свойство по-умолчанию (см константу LOADING)
        //            true - автоматическое переключение свойства по-умолчанию
        // silent - если запрос к серверу закончится кодом 401, не перенаправлять на sing-in
        let request = function (method = 'post', url, jsonObj = {}, hideAlert = true,
                                busyFlag = true, designDelay = false, silent = false)
        {
            if (hideAlert) {
                alert.hide();
                //vm.$forceUpdate();
            }
            let busyFlagName = LOADING;
            let setBFlag = true;
            if (typeof busyFlag == "boolean") {
                setBFlag = busyFlag && LOADING in this
            } else {
                busyFlagName = busyFlag
            }
            if (setBFlag) { Vue.set(this, busyFlagName, true) }
            let requestStart = Date.now();
            let delay = 0;
            if (typeof designDelay == "boolean" && designDelay) {
                delay = NORMAL_DESIGN_DELAY;
            } else if (typeof designDelay == "number") {
                delay = designDelay;
            }
            return new Promise((resolve, reject) => {
                if (isNotEmpty(sessionStorage.jwt)) axios.defaults.headers.common[AUTH_HEADER] = sessionStorage.jwt
                axios.defaults.headers.common['Content-Type'] = 'application/json'
                axios({
                    method: method,
                    url: url,
                    data: jsonObj
                })
                    .then((response) => {
                        wait(delay ? delay - (Date.now() - requestStart) : 1, response).then((response) => {
                            try {

                                let auth = response.headers[AUTH_HEADER];
                                if (isNotEmpty(auth) && auth != sessionStorage.jwt) {
                                    sessionStorage.jwt = auth
                                    if (localStorage.jwt) {
                                        localStorage.jwt = auth
                                    }
                                    store.commit(LAST_TOKEN_UPDATE);
                                    console.log("Token updated from the response header.");
                                }
                                if (response && response.data) {
                                    let data = response.data;
                                    if (isValidResponse(data)) {
                                        if (data.success) {
                                            resolve(data.result, data.messages)
                                            /* После обработки, потому что фильтр сообщений может использовать
                                            *  данные полученные из запроса */
                                            messages.addAll(data.messages);
                                        } else {
                                            reject(new RequestError(response, false));
                                        }
                                    } else {
                                        // Какой то ответ от сервера есть, но неправильный
                                        reject(new RequestError(response, true));
                                    }
                                } else {
                                    // Такого не должно на бэкенде
                                    reject(new RequestError(response, true));
                                }
                            } finally {
                                if (setBFlag) { Vue.set(this, busyFlagName, false) }
                            }
                        })
                    })
                    .catch((e) => {
                        wait(delay ? delay - (Date.now() - requestStart) : 1, e).then((e) => {
                            try {

                                if (e.response) {
                                    if (e.response.status == CODE_UNAUTHORIZED) {
                                        if (!silent) handleUnauthorized();
                                    } else {
                                        // The request was made and the server responded with a status code
                                        // that falls out of the range of 2xx
                                        console.log(e)
                                        reject(new RequestError(e.response, true));
                                    }
                                } else if (e.request) {
                                    // The request was made but no response was received
                                    // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                                    // http.ClientRequest in node.js
                                    console.log(e.request);
                                    reject(new RequestError(null, true));
                                } else {
                                    // Something happened in setting up the request that triggered an Error
                                    console.log('Error', e.message);
                                    reject(new RequestError(null, true));
                                }

                            } finally {
                                if (setBFlag) { Vue.set(this, busyFlagName, false) }
                            }
                        })
                    })
            })
        }

        let download_file = function (url, jsonObj = {}, file_name) {
            return new Promise((resolve, reject) => {
                if (isNotEmpty(sessionStorage.jwt)) axios.defaults.headers.common[AUTH_HEADER] = sessionStorage.jwt
                axios({
                    method: 'get',
                    url: url,
                    data: jsonObj,
                    responseType: "blob"
                }).then((result) => {
                    if (result.data.type.includes("json")) {
                        result.data.text().then(text => {
                            let json = JSON.parse(text);
                            if (isValidResponse(json) && json.errors && json.errors.length > 0) {
                                let msg = json.errors[json.errors.length - 1];
                                alert.show(msg.code + ": " + msg.message);
                            } else {
                                alert.show("Unable to download file.");
                            }
                        })
                        reject(result.data);
                    } else {
                        // Правильный ответ, скачиваем
                        fileDownload(result.data, file_name);
                        resolve(result.data)
                    }
                }).catch((e) => {
                    reject(e);
                });
            });
        }


        Vue.prototype.$post = function (url, jsonObj = {}, hideAlert = true, busyFlag = true,
                                        designDelay = false)
        {
            let fn = request.bind(this);
            return fn('post', url, jsonObj, hideAlert, busyFlag, designDelay, false)
        }

        Vue.prototype.$get = function (url, hideAlert = true, busyFlag = true,
                                       designDelay = false)
        {
            let fn = request.bind(this);
            return fn('get', url, {}, hideAlert, busyFlag, designDelay, false)
        }

        Vue.prototype.$patch = function (url, jsonObj = {}, hideAlert = true, busyFlag = true,
                                         designDelay = false)
        {
            let fn = request.bind(this);
            return fn('patch', url, jsonObj, hideAlert, busyFlag, designDelay, false)
        }

        Vue.prototype.$http_delete = function (url, jsonObj = {}, hideAlert = true, busyFlag = true,
                                               designDelay = false, silent = false)
        {
            let fn = request.bind(this);
            return fn('delete', url, jsonObj, hideAlert, busyFlag, designDelay, silent)
        }

        Vue.prototype.$download = function (url, jsonObj = {}, file_name) {
            let fn = download_file.bind(this);
            return fn(url, jsonObj, file_name);
        }

        Vue.post = Vue.prototype.$post
        Vue.get = Vue.prototype.$get
        Vue.patch = Vue.prototype.$patch
        Vue.http_delete = Vue.prototype.$http_delete
        Vue.download = Vue.prototype.$download
    }
}

export function status2message(code) {
    //console.log('status2message: ' + code)
    switch (code) {
        case 401:
            return i18n.t("error.unauthorized")
        case 422:
            return i18n.t("error.422")
        default:
            return i18n.t("error.serviceDown", [code])
    }
}

export function backerror2message(code, message) {
    console.log('backerror2message: ' + code)
    switch (code) {
        case errs.CODE_ACC_ALREADY_EXISTS:
            return i18n.t("error.32")
        default:
            return message
    }
}

function isValidResponse(candidate) {
    if (candidate instanceof Object) {
        return Object.prototype.hasOwnProperty.call(candidate, 'result') &&
            Object.prototype.hasOwnProperty.call(candidate, 'success') &&
            Object.prototype.hasOwnProperty.call(candidate, 'errors') &&
            Object.prototype.hasOwnProperty.call(candidate, 'messages');
    } else {
        return false;
    }
}

const SIGN_IN_ROUTE_PATH = 'sign-in';

export function handleUnauthorized() {
    // ToDo: Сообщение срок действия сессии вышел?
    let current = router.currentRoute;
    if (current.name != SIGN_IN_ROUTE_PATH && !current.path.endsWith(SIGN_IN_ROUTE_PATH)) {
        router.push({ name: SIGN_IN_ROUTE_PATH })
    }
}